// Noop SDK plugins for OSS builds
// This file provides the same interface as the enterprise SDK plugins
// but without any actual functionality

/**
 * No-op version of SDK plugins initialization for OSS builds.
 */
export function initializePlugins() {
  // No-op for OSS builds
}
